"use client";

import { AnimatePresence, motion } from "motion/react";

import { cn } from "@shared/ui/utils";

import { CubesBg25Svg } from "~/assets/svg/cubes-bg-25";
import { CubesBg50Svg } from "~/assets/svg/cubes-bg-50";
import { CubesBg75Svg } from "~/assets/svg/cubes-bg-75";

interface AnimatedBackgroundProps {
  className?: string;
}

const cubes = [
  {
    component: () => <CubesBg25Svg className={cn(cubeStyle)} />,
    initial: { opacity: 0 },
    animate: { opacity: [0.25, 1, 0.25], transition: { duration: 2.5, repeat: Infinity, repeatDelay: 1.25 } },
  },
  {
    component: () => <CubesBg50Svg className={cn(cubeStyle)} />,
    initial: { opacity: 0 },
    animate: {
      opacity: [0.25, 1, 0.25],
      transition: { duration: 2.5, delay: 1.25, repeat: Infinity, repeatDelay: 2.5 },
    },
  },
  {
    component: () => <CubesBg75Svg className={cn(cubeStyle)} />,
    initial: { opacity: 0 },
    animate: { opacity: [0.25, 1, 0.25], transition: { duration: 2.5, delay: 2.5, repeat: Infinity } },
  },
];

const cubeStyle = cn("h-full opacity-75");
const divStyle = cn("pointer-events-none absolute top-0 -z-20 h-[1219px] w-[949px]");

export const AnimatedBackground = ({ className }: AnimatedBackgroundProps) => {
  return cubes.map((cube, index) => (
    <AnimatePresence key={index} mode="wait">
      <motion.div
        initial={cube.initial}
        animate={cube.animate}
        exit={{ opacity: 0, transition: { duration: 3 } }}
        className={cn(divStyle, className)}
      >
        {cube.component()}
      </motion.div>
    </AnimatePresence>
  ));
};
